// components/EquiposChips.jsx
import { Box, Typography } from "@mui/material";

// Equipos de un cliente, en discreto: etiqueta con borde fino y gris, un punto de color tenue por tipo y la cantidad en negrita (antes eran chips de colores fuertes).
const TIPOS = {
  radio: { nombre: "Radio", color: "#1976d2" },
  modem: { nombre: "Módem", color: "#2e7d32" },
  bateria: { nombre: "Batería", color: "#ed6c02" },
  chip: { nombre: "Chip", color: "#7b1fa2" },
  placa: { nombre: "Placa", color: "#78909c" },
  varios1: { nombre: "Varios 1", color: "#0288d1" },
  varios2: { nombre: "Varios 2", color: "#0288d1" },
};

export default function EquiposChips({ equiposMap, codServicioCliente }) {
  const tipos = equiposMap[String(codServicioCliente)];
  if (!tipos) return <Typography variant="body2" color="text.secondary">Sin equipos</Typography>;

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
      {Object.entries(tipos).map(([tipo, cantidad]) => {
        const cfg = TIPOS[String(tipo).toLowerCase()] || { nombre: tipo, color: "#90a4ae" };
        return (
          <Box
            key={tipo}
            component="span"
            sx={{
              display: "inline-flex", alignItems: "center", gap: 0.5, px: 0.75, height: 19, borderRadius: "10px",
              border: "1px solid", borderColor: "divider", color: "text.secondary", fontSize: "0.68rem", lineHeight: 1, whiteSpace: "nowrap",
            }}
          >
            <Box component="span" sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: cfg.color, opacity: 0.7, flexShrink: 0 }} />
            {cfg.nombre}
            <Box component="b" sx={{ color: "text.primary", fontWeight: 700 }}>{cantidad}</Box>
          </Box>
        );
      })}
    </Box>
  );
}
